// Libraries
import {
  Directive,
  HostListener,
  Input
} from '@angular/core';

// Services
import { ScrollToService } from './scroll-to.service';

/**
 * Directive to scroll to element.
 *
 * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
 * @export
 */
@Directive({
    selector: '[wpScrollTo]'
})
export class ScrollToDirective {
  // Public properties
  /**
   * Scroll to element ref or element id.
   */
  @Input('scrollTo') scrollTo: any;
  /**
   * Scroll duration.
   */
  @Input('scrollDuration') scrollDuration = 500;
  /**
   * Scroll offset
   */
  @Input('scrollOffset') scrollOffset = 0;

  // Public methods
  /**
   * Creates an instance of ScrollToDirective.
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof ScrollToDirective
   */
  constructor(private scrollToService: ScrollToService) {}

  /**
   * Handles mouse down event.
   */
  @HostListener('mousedown')
  onMouseClick() {
    // Check if is scroll to top or not
    if (!this.scrollTo || this.scrollTo === 'top') {
      this.scrollToService.scrollToTop(this.scrollDuration, this.scrollOffset);
    } else {
      this.scrollToService.scrollTo(this.scrollTo, this.scrollDuration, this.scrollOffset);
    }
  }
}
